import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { ThemeProvider } from 'styled-components';

import {
	Wrapper,
	SelectValue,
	SelectDropdown,
	SelectOptions,
	SelectOptionButton,
} from './styles';
import Utils from '../../../utils';
import useClickOutside from '../../../utils/customHooks/useClickOutside';

export enum SelectTheme {
	DARK = 'DARK',
	LIGHT = 'LIGHT',
}

export interface SelectOption {
	value: string | number;
	label: string | React.ReactNode;
}

interface SelectProps {
	value: string | number;
	options: SelectOption[];
	onChange: (option: SelectOption) => void;
	placeholder?: string;
	theme?: SelectTheme;
}

const Select = ({
	value,
	options,
	placeholder,
	theme = SelectTheme.LIGHT,
	onChange,
}: SelectProps) => {
	const wrapperElement = React.useRef<HTMLDivElement>(null);
	const [isOpen, setIsOpen] = React.useState(false);
	useClickOutside(wrapperElement, isOpen, () => setIsOpen(false));

	const handleChange = (option: SelectOption) => {
		onChange(option);
		setIsOpen(false);
	};

	const selectedOption = options.find(option => option.value === value);
	const displayedLabel = selectedOption ? selectedOption.label : placeholder;

	return (
		<ThemeProvider theme={{ theme }}>
			<Wrapper ref={wrapperElement}>
				<SelectValue
					isOpen={isOpen}
					onClick={() => setIsOpen(prevState => !prevState)}
				>
					{typeof displayedLabel === 'string'
						? <Translate value={displayedLabel || ''} />
						: displayedLabel
					}
					{Utils.getSvgIcon('iconset_down')}
				</SelectValue>
				{isOpen &&
					<SelectDropdown>
						<SelectOptions>
							{options.map(option => (
								<li key={option.value}>
									<SelectOptionButton
										type="button"
										isActive={option.value === value}
										onClick={() => handleChange(option)}
									>
										{typeof option.label === 'string'
											? <Translate value={option.label || ''} />
											: option.label
										}
									</SelectOptionButton>
								</li>
							))}
						</SelectOptions>
					</SelectDropdown>
				}
			</Wrapper>
		</ThemeProvider>
	);
};

export default Select;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/Select/index.tsx